import useSWR from 'swr';
import { Artist } from 'types';
import api from 'utils/api';

export function useMyCcArtists() {
  const {
    data,
    error,
    mutate: refetch,
  } = useSWR<Artist[]>(
    'my-cc-artists',
    async () => {
      const artists: Artist[] = await api.collabClub.getMyCcArtists();
      return artists;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 60 * 1000, // 1 minute
    }
  );

  return {
    myArtists: data || [],
    isLoading: !data && !error,
    error,
    refetch,
  };
}
